import { Component } from '@angular/core';

@Component({
  selector: 'app-e-details-page',
  templateUrl: './e-details-page.component.html',
  styleUrls: ['./e-details-page.component.css'],
})
export class EDetailsPageComponent {
  selectedSize: any;
  selectedColor: any;
  images = [
    'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRcAsz2YVzSmSJhQaQ0GVV-GpVX4kYlutL-lg&s',

    'https://m.media-amazon.com/images/I/31TnppygRvL._AC_.jpg',

    'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQub9DPVYNSjBqFk9Upl_RKk9DeLohSKmgqaw&s',

    'https://qafelh.com/storage/2022/10/Dingtalk_20231104111621-large.webp',

    'https://m.media-amazon.com/images/I/41u9QYSoA-L._AC_.jpg',

    'https://qafelh.com/storage/2022/10/Dingtalk_20231104111621-large.webp',

    'https://m.media-amazon.com/images/I/31TnppygRvL._AC_.jpg',
  ];
  colors = [
    'red',
    'blue',
    'green',
    'yellow',
    'orange',
    'purple',
    'pink',
    'cyan',
    'teal',
    'magenta',
    'lime',
    'brown',
    'black',
    'white',
    'gray',
    'gold',
    'silver',
    'maroon',
    'navy',
    'olive',
  ];

  sizes = [30, 35, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50];
  responsiveOptions = [
    {
      breakpoint: '1024px',
      numVisible: 5,
      columns: 5,
    },
    {
      breakpoint: '600px',
      numVisible: 4,
      columns: 4,
    },
  ];
}
